/* src/app/shared/promotion-dialog/promotion-dialog.component.scss */
.close {
  font-size: 14px !important;
  --padding-end: 10px;
}
.img-product {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.description {
  font-size: 14px;
}
/*# sourceMappingURL=promotion-dialog.component-BVTLJE7V.css.map */
